import { useActiveMember } from 'hooks';
import { castArray, compact } from 'lodash';
import { lazy } from 'react';
import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { t } from 'utils/localize';
import { IAccessControlProps } from './AccessControl';
const NotAllowed = lazy(() => import('containers/error/NotAllowed'));

export interface IValidatePermissionProps extends Pick<IAccessControlProps, 'permissions'> {
  fallback?: React.ReactElement;
}

export const ValidatePermission: React.FC<IValidatePermissionProps> = (props) => {
  const { children, permissions, fallback = <NotAllowed message={t(`Permission denied`)} /> } = props;

  const activeMember = useActiveMember();
  const isPermissionAllowed = compact(castArray(permissions)).every((permission) => {
    return activeMember?.position && activeMember.position[permission];
  });
  const location = useLocation();

  return isPermissionAllowed ? <>{children}</> : location.pathname === '/' ? <Navigate to="/login" /> : fallback;
};
